export default "__VITE_ASSET__DCoqmqOO__"